document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".shop-the-look__content");

  if (!slider) return;

  let isDragging = false;
  let startX = 0;
  let scrollStart = 0;
  let hasDragged = false;
  const dragThreshold = 5; // Minimum distance to consider as dragging

  const startDrag = (e) => {
    e.preventDefault();
    isDragging = true;
    hasDragged = false;
    slider.classList.add("is-grabbing");
    startX = e.pageX;
    scrollStart = slider.scrollLeft;
  };

  const stopDrag = () => {
    isDragging = false;
    slider.classList.remove("is-grabbing");
  };

  const handleDrag = (e) => {
    if (!isDragging) return;
    const deltaX = e.pageX - startX;
    if (Math.abs(deltaX) > dragThreshold) {
      hasDragged = true;
    }
    slider.scrollLeft = scrollStart - deltaX;
  };

  const preventClickOnDrag = (e) => {
    if (hasDragged) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  // Event listeners
  slider.addEventListener("mousedown", startDrag);
  document.addEventListener("mouseup", stopDrag);
  document.addEventListener("mousemove", handleDrag);
  slider.addEventListener("mouseleave", stopDrag);

  // Prevent product card clicks while dragging
  slider.querySelectorAll("li a").forEach((card) => {
    card.addEventListener("click", preventClickOnDrag);
  });
});
